import React from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import SignaturePad from "react-signature-canvas";
import { connect } from "react-redux";
import {
  getContactsActions,
  getUserRolesAction,
} from "../../actions/UserActions";
import {
  getAllTransactionsAction,
  getAllTasksAction,
  createTaskAction,
} from "../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../actions/BuyerTransactionActions";
import { addDocAction, uploadDocumentAction } from "../../actions/DocActions";
import { addPublicFormAction } from "../../actions/PublicFormsActions";
import {
  formatPhoneNumber,
  toastMessage,
  cryptoTokenDecode,
  convertTimeToMinutes,
  getContingencyData,
  checkObjExists,
} from "../Common/Common";
import moment from "moment";
import html2pdf from "html2pdf.js";
import * as code from "../../config/Constants";
import * as message from "../../config/CommonMessages";
import StickyHeader from "./StickyHeader";
import { HelpOutline } from "@material-ui/icons";
import FormActionPrompt from "./FormActionPrompt";
import InputMask from "react-input-mask";
import GenerateQRcode from "./GenerateQRcode";
var _ = require("lodash");

class CheckInForm extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    let studioName = localStorage.getItem("companyName");
    this.state = {
      contacts: [],
      transactions: [],
      transaction: {},
      events: [],
      contingencies: [],
      appointmentDate: "",
      transactionId: "",
      userType: userType.toUpperCase(),
      studioName: !!studioName ? studioName.toUpperCase() : "",
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showPrompt: false,
      promptType: "",
      selectedTransClientEmail: "",
      showQRcodePrompt: false,
      errors: {},
      showLoader: false,
    };
    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  componentWillMount() {
    this.getAllTransactions();
  }

  handleTransactionSelection(e) {
    if (e) {
      this.setState({
        transaction: e,
        transactionId: e.id,
        contingencies: e.contingencies,
        selectedTransClientEmail: e.hasGuardian
          ? e.guardianEmail
          : e.clientEmail,
        errors: {},
      });
    }

    this.getAllTasks(e.id);
  }

  clearTransactionSelection() {
    this.handleClosePrompt();
    this.setState({
      transaction: {},
      errors: {},
    });
  }

  handleShowPrompt(name) {
    this.setState({
      showPrompt: true,
      promptType: name,
    });
  }

  handleClosePrompt() {
    this.setState({
      showPrompt: false,
      promptType: "",
    });
  }

  handleShowQRcodePrompt() {
    this.setState({
      showQRcodePrompt: true,
    });
  }

  handleCloseQRcodePrompt() {
    this.setState({
      showQRcodePrompt: false,
    });
  }

  getAllTransactions(id) {
    this.setState({
      showLoader: true,
    });
    if (
      this.state.userType === message.VENDOR &&
      this.state.currentRole === message.BUYERAGENT
    ) {
      this.props.getVendorTransactionsAction().then((vendorRes) => {
        this.setState({
          transactions: this.props.vendorTransactions.data || [],
          showLoader: false,
        });
      });
    } else if (
      this.state.userType === message.BUYER &&
      this.state.currentRole === message.BUYER
    ) {
      this.props.getBuyerTransactionsAction().then((buyerRes) => {
        this.setState({
          transactions: this.props.buyerTransactions.data || [],
          showLoader: false,
        });
      });
    } else {
      this.props.getAllTransactionsAction("INPROGRESS").then((res) => {
        this.setState({
          transactions: this.props.transactions.data || [],
          showLoader: false,
        });
      });
    }
  }

  getAllTasks(id) {
    this.props.getAllTasksAction(id).then((res) => {
      this.setState({
        events: this.props.tasks.data,
      });
    });
  }

  async exportFormToPDF() {
    this.setState({
      showLoader: true,
    });
    this.handleClosePrompt();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.transaction.clientFirstName.trim() +
      (this.state.transaction.clientLastName
        ? " " + this.state.transaction.clientLastName.trim()
        : "");

    let fileName =
      "checkin" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1000 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.addDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .uploadDocumentAction(formData, transId, undefined, fileUploadName)
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf().set(opt).from(form).save();
              this.setState({
                showLoader: false,
              });
            });
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  sendForm(transId) {
    this.setState({
      showLoader: true,
    });
    let transaction = this.state.transaction;
    let senderEmailToken =
      transaction && transaction.hasGuardian
        ? {
            email: "@guardian_email",
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            dataValue: "guardian_firstname",
            contingency: "Guardian",
          }
        : transaction.clientEmail
        ? {
            email: "@client_email",
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            dataValue: "client_firstname",
            contingency: "Client",
          }
        : "";
    let senderPhoneToken =
      transaction && transaction.hasGuardian
        ? {
            phone: "@guardian_phone",
            phoneValue: transaction.guardianPhone,
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            contingency: "Guardian",
          }
        : transaction.clientPhone
        ? {
            phone: "@client_phone",
            phoneValue: transaction.clientPhone,
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            contingency: "Client",
          }
        : "";

    this.handleClosePrompt();

    let newEventStart = moment();
    let newEventEnd = moment();
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );

    let appointmentDate = getContingencyData(
      this.state.contingencies,
      "First Appointment",
      "startDate"
    );

    let newPublicForm = {
      form: "checkin",
      transactionId: transId,
      expiresOn: new Date(moment(appointmentDate).subtract(5, "days")),
      auth: false,
    };
    this.props.addPublicFormAction(newPublicForm).then((newPubResConsent) => {
      //   console.log(
      //     "PUBLIC FORM addPublicFormAction consent res: ",
      //     newPubResConsent
      //   );
    });

    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        `Consent Form for ${senderEmailToken.firstname} ${senderEmailToken.lastname}`,
      ],
      communicationTo: [senderEmailToken.email],
      communicationType: "EMAIL",
      contingency: senderEmailToken.contingency,
      day: 0,
      description: [
        `<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="${senderEmailToken.dataValue}">${senderEmailToken.firstname}</a>!</p><p></p><p>The checkin form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@checkin_form_url</p>`,
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Consent Form - Email",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({
            showLoader: false,
          });
          toastMessage(code.SUCCESS, "Form sent");
          //   console.log(createEventRes);
        }
      });
    }

    if (senderPhoneToken.phoneValue) {
      newEvent = {
        assignee: "",
        campaign: "",
        communicationSubject: [""],
        communicationTo: [senderPhoneToken.phone],
        communicationType: "TEXT",
        contingency: "First Appointment",
        day: 0,
        description: [
          `Hey ${senderPhoneToken.firstname}! We emailed you the checkin form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!`,
        ],
        document: false,
        eventEndDate: newEventEnd,
        eventStartDate: newEventStart,
        eventType: "COMMUNICATION",
        isReminder: false,
        reminderDate: "",
        reminderTime: 540,
        specialTask: [""],
        status: "SCHEDULED",
        time: newEventTime,
        timeZone: "240",
        title: "Consent Form - Text",
        transactionId: transId,
      };

      if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
        this.props.createTaskAction(newEvent).then((createEventRes) => {
          if (createEventRes.status === code.OK) {
            this.setState({
              showLoader: false,
            });
            //   console.log(createEventRes);
          }
        });
      }
    }
  }

  handleChange = (e, key) => {
    if (
      this.state.transaction &&
      Object.keys(this.state.transaction).length > 0
    ) {
      this.setState({
        transaction: {
          ...this.state.transaction,
          [key]: e.target.value,
        },
      });
    }
  };

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    let transactions = this.state.transactions;
    let transaction = this.state.transaction;
    let events = this.state.events;
    let listedTransactions = [];

    for (let i = 0; i < transactions.length; i++) {
      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),
        id: transactions[i]._id,
        clientFirstName: transactions[i].dsd.buyer[0].firstname,
        clientLastName: transactions[i].dsd.buyer[0].lastname
          ? transactions[i].dsd.buyer[0].lastname
          : "",
        clientEmail: transactions[i].dsd.buyer[0].email,
        clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
        guardianName: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].firstname +
            (transactions[i].dsd.closingAgents[0].lastname
              ? " " + transactions[i].dsd.closingAgents[0].lastname
              : "")
          : "",
        guardianEmail: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].email
          : "",
        guardianPhone: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].mobileNumber
          : "",
        contingencies: transactions[i].contingencies,
        status: transactions[i].status,
        hasGuardian:
          transactions[i].dsd.closingAgents.length !== 0 ? true : false,
        shortName: transactions[i].shortName,
        description: transactions[i].dsd.heldBy,
      });
    }

    return (
      <div className="admin-steps admin-content-area">
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <StickyHeader
          listedTransactions={listedTransactions}
          transaction={this.state.transaction}
          handleTransactionSelection={this.handleTransactionSelection.bind(
            this
          )}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
          handleShowPrompt={this.handleShowPrompt.bind(this)}
          selectedTransClientEmail={this.state.selectedTransClientEmail}
          handleShowQRcodePrompt={this.handleShowQRcodePrompt.bind(this)}
          formType="checkin"
          errorHandler={this.errorHandler.bind(this)}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12}>
                <h3 className="title-medium font-600 mt-2 mb-3 pt-3">
                  Register for Tattoo City Convention communications,
                  <br />
                  updates, and future events
                </h3>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>
                    :
                  </Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      this.handleChange(e, "clientFirstName")
                    }
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientFirstName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    onChange={(e) => this.handleChange(e, "clientLastName")}
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientLastName
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Email:</Form.Label>
                  <Form.Control
                    type="email"
                    onChange={(e) => this.handleChange(e, "clientEmail")}
                    value={
                      checkObjExists(transaction)
                        ? transaction.clientEmail
                        : ""
                    }
                    isInvalid={!!this.state.errors.clientEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Mobile Number:</Form.Label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    onChange={(e) => this.handleChange(e, "clientPhone")}
                    value={
                      checkObjExists(transaction)
                        ? formatPhoneNumber(transaction.clientPhone)
                        : ""
                    }
                    name="clientPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>

        <FormActionPrompt
          transaction={this.state.transaction}
          promptType={this.state.promptType}
          showPrompt={this.state.showPrompt}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          sendForm={this.sendForm.bind(this)}
          handleClosePrompt={this.handleClosePrompt.bind(this)}
          clearTransactionSelection={this.clearTransactionSelection.bind(
            this
          )}
        />
        <GenerateQRcode
          transaction={this.state.transaction}
          formType="checkin"
          showQRcodePrompt={this.state.showQRcodePrompt}
          handleCloseQRcodePrompt={this.handleCloseQRcodePrompt.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    transactions: state.reducer.transactions,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    tasks: state.reducer.tasks,
    addPublicFormData: state.reducer.addPublicFormData,
  };
};

export default connect(mapStateToProps, {
  getAllTransactionsAction,
  getVendorTransactionsAction,
  getBuyerTransactionsAction,
  getContactsActions,
  getUserRolesAction,
  getAllTasksAction,
  addDocAction,
  uploadDocumentAction,
  createTaskAction,
  addPublicFormAction,
})(CheckInForm);
